import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken, getRefreshToken, setRefreshToken, removeRefreshToken } from '@/utils/auth'
import { login, getUserInfo } from '@/api/auth'
import { getMenusByAdminId } from '@/api/menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    userInfo: null,
    menus: []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    }
  },
  actions: {
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          const { data } = res
          commit('SET_TOKEN', data.accessToken)
          setToken(data.accessToken)
          setRefreshToken(data.refreshToken)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          const { data } = res
          commit('SET_USER_INFO', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getMenus({ commit }, adminId) {
      return new Promise((resolve, reject) => {
        getMenusByAdminId(adminId).then(res => {
          const { data } = res
          commit('SET_MENUS', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        removeToken()
        removeRefreshToken()
        resolve()
      })
    }
  }
})